//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  auth: false,
  async asyncData ({ store }) {
    if (!store.state.collections.length) {
      await store.dispatch('GET_WebsiteData')
    }
  },
  computed: {
    collections () {
      return this.$store.state.collections || []
    }
  },
  methods: {
    slugify (value) {
      return (value || '')
        .toString()
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '')
    },
    getCollectionSlug (collection) {
      if (collection && collection.id != null) {
        return String(collection.id)
      }
      return this.slugify(collection ? collection.name : '')
    },
    collectionProducts (collection) {
      return Array.isArray(collection && collection.products)
        ? collection.products
        : []
    }
  },
  head: {
    title: 'Colecciones',
    meta: [
      { hid: 'og:title', name: 'og:title', content: 'Colecciones' },
      { hid: 'description', name: 'description', content: 'Colecciones de productos' }
    ]
  }
}
